module.exports = __webpack_public_path__ + "media/images/application/social_sharing/facebook-a7ff58c758c4c63f5e8ad28cae7b168c.png";